export const defaultInvoiceForm = (): InvoiceForm => ({
  product: {
    code: '',
    resume: '',
  },
  date: '',
  crt: '',
  invoiceNumber: "",
  invoiceValue: 0,
  invoiceQuantity: 0,
  unitCostReal: 0,
  realValue: 0,
  status: 'RECEIVED',
  totalCost: 0,
  unitCostTotal: 0,
  unitSale: 0,
  unitProfit: 0,
  totalProfit: 0,
  company: {
    id: 0,
    name: '',
  },
  invoiceTaxes: [],
  observation: '',
  locked: false,
  labeled: false,
  group: {
    id: 0,
    number: 0,
    name: ""
  }
});

export const defaultTaxForm = (): TaxForm => ({
  name: '',
  value: 0,
  description: '',
});

export const defaultCompanyForm = (): CompanyForm => ({
  name: '',
});

export const defaultDepositForm = (): DepositForm => ({
  date: '',
  reference: '',
  value: 0,
  company: {
    id: 0,
    name: '',
  },
  locked: false,
  group: {
    id: 0,
    number: 0,
    name: ""
  },
});

export const defaultLogisticForm = (): LogisticForm => ({
  quantityVolume: 0,
  nrcInvoiceNumber: "",
  clientInvoiceNumber: "",
  crt: "",
  clientName: "",
  warehouseDispatchDate: "",
  revenueDate: "",
  customsDate: "",
  storageDate: "",
  clientDate: "",
  releaseDate: "",
  observation: "",
  company: {
    id: 0,
    name: '',
  },
  group: {
    id: 0,
    number: 0,
    name: ""
  },
});

export const defaultLogisticOriginForm = (): LogisticOriginForm => ({
  originInvoiceNumber: "",
  quantityVolume: 0,
  releaseDate: "",
  company: {
    id: 0,
    name: '',
  },
  group: {
    id: 0,
    number: 0,
    name: ""
  },
});

export const defaulManyDepositsForm = (): ManyDepositsForm => ({
  reference: '',
});

export const defaultBlurInvoiceForm = (
  value = false,
): Record<keyof InvoiceForm, boolean> => ({
  product: value,
  date: value,
  crt: value,
  invoiceNumber: value,
  invoiceValue: value,
  invoiceQuantity: value,
  unitCostReal: value,
  realValue: value,
  status: value,
  totalCost: value,
  unitCostTotal: value,
  unitSale: value,
  unitProfit: value,
  totalProfit: value,
  company: value,
  invoiceTaxes: value,
  observation: value,
  locked: value,
  labeled: value,
  group: value
});

export const defaultBlurTaxForm = (
  value = false,
): Record<keyof TaxForm, boolean> => ({
  name: value,
  value: value,
  description: value,
});

export const defaultBlurCompanyForm = (
  value = false,
): Record<keyof CompanyForm, boolean> => ({
  name: value,
});

export const defaultBlurLogisticForm = (
  value = false,
): Record<keyof LogisticForm, boolean> => ({
  quantityVolume: value,
  crt: value,
  clientName: value,
  company: value,
  nrcInvoiceNumber: value,
  clientInvoiceNumber: value,
  warehouseDispatchDate: value,
  revenueDate: value,
  customsDate: value,
  storageDate: value,
  clientDate: value,
  releaseDate: value,
  observation: value,
  group: value,
});

export const defaultBlurLogisticOriginForm = (
  value = false,
): Record<keyof LogisticOriginForm, boolean> => ({
  originInvoiceNumber: value,
  quantityVolume: value,
  releaseDate: value,
  company: value,
  group: value,
});

export const defaultBlurDepositForm = (
  value = false,
): Record<keyof DepositForm, boolean> => ({
  date: value,
  company: value,
  value: value,
  reference: value,
  locked: value,
  group: value,
});

export const defaultSearchFilter = () => ({
  filter: {
    page: 1,
    limit: 15,
    filter: [],
    orderBy: [],
  },
  data: {
    meta: {
      total: 0,
      lastPage: 1,
      currentPage: 1,
      perPage: 15,
    },
    data: [],
  },
});

export const defaultBlurManyDeposits = (
  value = false,
): Record<keyof ManyDepositsForm, boolean> => ({
  reference: value,
});
